module.exports = function(value) {
	return JSON.parse(value);
};


// WEBPACK FOOTER //
// ./app/statamic/resources/js/filters/parse.js